import { render, staticRenderFns } from "./CostumersIndex.vue?vue&type=template&id=cb794ef6"
import script from "./CostumersIndex.vue?vue&type=script&lang=js"
export * from "./CostumersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports